/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The request body for exporting directory
 */
export type ExportDirectoryRequest = {
    /**
     * The group
     */
    group?: ExportDirectoryRequest.group;
    /**
     * The family name format
     */
    family_name_format?: ExportDirectoryRequest.family_name_format;
    /**
     * Show all members
     */
    show_all_members?: boolean;
    /**
     * The order by field
     */
    order_by?: string;
    /**
     * The all selected field
     */
    allSelected?: boolean;
    /**
     * Hide private data
     */
    hide_private_data?: boolean;
    /**
     * Show labels
     */
    show_labels?: boolean;
    /**
     * The filters
     */
    filters?: {
        /**
         * Archived exists filter
         */
        'archived:exists'?: boolean;
        /**
         * Email default filter
         */
        'or:emailDefault'?: string;
        /**
         * Phone default filter
         */
        'or:phoneDefault'?: string;
    };
    /**
     * Selected fields
     */
    selected_fields?: Array<{
        /**
         * The type of the selected field
         */
        type?: string;
    }>;
    /**
     * The directory template ID
     */
    customize_directory_template?: string;
    /**
     * Template for individual directory entry
     */
    customize_directory_individual?: string;
    /**
     * Template for single parent directory entry
     */
    customize_directory_one_parent?: string;
    /**
     * Template for first two adults in family
     */
    customize_directory_first_two_adults?: string;
    /**
     * Template for additional adults
     */
    customize_directory_adults?: string;
    /**
     * Template for children
     */
    customize_directory_children?: string;
    /**
     * Sorting option for children
     */
    customize_directory_children_sort?: ExportDirectoryRequest.customize_directory_children_sort;
    /**
     * Format for listing children
     */
    customize_directory_children_separate?: ExportDirectoryRequest.customize_directory_children_separate;
    /**
     * Option for handling different last names
     */
    customize_directory_last_name_selection?: ExportDirectoryRequest.customize_directory_last_name_selection;
};

export namespace ExportDirectoryRequest {

    /**
     * The group
     */
    export enum group {
        INDIVIDUALS = 'individuals',
        ENTIRE_FAMILY = 'entire_family',
        LIST_FAMILY = 'list_family',
    }

    /**
     * The family name format
     */
    export enum family_name_format {
        ADULTS = 'Adults',
        ADULTS_AND_CHILDREN = 'Adults and Children',
        FAMILY_NAME = 'Family Name',
        FORMAL_FAMILY_NAME = 'Formal Family Name',
    }

    /**
     * Sorting option for children
     */
    export enum customize_directory_children_sort {
        ALPHABETICAL = 'alphabetical',
        AGE = 'age',
    }

    /**
     * Format for listing children
     */
    export enum customize_directory_children_separate {
        SEPARATE = 'separate',
        COMMAS = 'commas',
    }

    /**
     * Option for handling different last names
     */
    export enum customize_directory_last_name_selection {
        ONCE = 'once',
        TWICE = 'twice',
    }


}

